import { render, staticRenderFns } from "./login.vue?vue&type=template&id=f04bea04&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=f04bea04&prod&lang=less&"
import style1 from "./login.vue?vue&type=style&index=1&id=f04bea04&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04bea04",
  null
  
)

export default component.exports